export default function ($translate) {
    return {
        KEYS: {
            NAME: 'NAME',
            EXTERNAL_ID: 'EXTERNAL_ID',
            DESCRIPTION: 'DESCRIPTION',
            HINT: 'HINT',
            POINTS: 'POINTS',
            LEVEL: 'LEVEL',
            ANSWER: 'ANSWER',
            CORRECT_ANSWER_NR: 'CORRECT_ANSWER_NR',
            CATEGORY: 'CATEGORY',
            ANSWER_FEEDBACK: 'ANSWER_FEEDBACK'
        },
        LABELS: {
            NAME: $translate.instant('questionImport.Name'),
            EXTERNAL_ID: $translate.instant('questionImport.External id'),
            DESCRIPTION: $translate.instant('questionImport.Description'),
            HINT: $translate.instant('questionImport.Question hint'),
            LEVEL: $translate.instant('questionImport.Level'),
            POINTS: $translate.instant('questionImport.Points'),
            ANSWER: $translate.instant('questionImport.Answer'),
            CORRECT_ANSWER_NR: $translate.instant('questionImport.Correct answer number'),
            CATEGORY: $translate.instant('questionImport.Category'),
            ANSWER_FEEDBACK: $translate.instant('questionImport.Answer feedback')
        },
        API_FIELD: {
            EXTERNAL_ID: 'externalId'
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/questions/fields/other/index.js